import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

const TIP_KEY = 'kidsevent_ai_tip_dismissed';
let cfgPromise = null;

export const loadAIConfig = () => {
  cfgPromise = cfgPromise || fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ai/config`).then((r) => r.json()).catch(() => { cfgPromise = null; return {}; });
  return cfgPromise;
};

export const useAIConfig = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { let on = true; loadAIConfig().then((c) => on && setCfg(c)); return () => { on = false; }; }, []);
  return cfg;
};

export const openAIAssistant = (text, source) => window.dispatchEvent(new CustomEvent(text ? 'kidsevent-ai-ask' : 'kidsevent-ai-open', { detail: text ? { text, source } : {} }));

export const AIFab = ({ size = 'w-12 h-12', className = '', testid = 'ai-fab', mobile = false }) => {
  const [tip, setTip] = useState(false);
  const d = useAIConfig()?.design || {};
  const left = d.position === 'left';
  const title = d.button_text || 'Frag unseren KI-Assistenten';

  useEffect(() => {
    if (sessionStorage.getItem(TIP_KEY) || (window.innerWidth < 768) !== mobile) return undefined;
    const t1 = setTimeout(() => setTip(true), 2500);
    const t2 = setTimeout(() => setTip(false), 9500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [mobile]);

  const close = () => { setTip(false); sessionStorage.setItem(TIP_KEY, '1'); };
  const label = d.show_button_label && !mobile;

  return (
    <div className={`relative ${className}`}>
      {tip && !label && (
        <div className={`absolute ${left ? 'left-14' : 'right-14'} bottom-1 flex items-start gap-1.5 bg-white rounded-xl shadow-lg pl-2.5 pr-6 py-2 w-max max-w-[185px] border border-sky-100 animate-fade-in-up`} data-testid="ai-fab-tooltip">
          <Sparkles className="w-3.5 h-3.5 shrink-0 text-sky-500 mt-[3px]" />
          <div className="min-w-0">
            <div className="text-[13px] font-semibold text-neutral-900 leading-tight">{title}</div>
            {d.tooltip_text !== '' && <div className="text-neutral-500 text-[11px] mt-0.5 leading-tight">{d.tooltip_text || 'Antwortet sofort'}</div>}
          </div>
          <button type="button" onClick={close} className="absolute top-0.5 right-1 text-neutral-400 hover:text-neutral-700 text-base leading-none p-0.5" aria-label="Schließen" data-testid="ai-fab-tooltip-close">×</button>
        </div>
      )}
      <button type="button" onClick={() => { close(); openAIAssistant(); }} aria-label={title}
        className={`relative flex items-center justify-center gap-2 ${label ? 'h-12 px-4' : size} rounded-full shadow-xl text-white transition-transform hover:scale-105 active:scale-95 ${d.button_color ? '' : 'bg-gradient-to-br from-sky-500 via-sky-700 to-[#0b2f5c]'}`}
        style={d.button_color ? { background: d.button_color } : undefined}
        data-testid={testid}>
        <span aria-hidden className="absolute -inset-[3px] rounded-full bg-[conic-gradient(from_0deg,#38bdf8,#facc15,#22d3ee,#38bdf8)] opacity-70 blur-[2px] animate-[spin_6s_linear_infinite] -z-10" />
        <Sparkles className="w-5 h-5 shrink-0" />
        {label && <span className="text-sm font-semibold whitespace-nowrap" data-testid={`${testid}-label`}>{title}</span>}
        {d.show_ai_badge !== false && <span className="absolute -top-2.5 right-0 whitespace-nowrap rounded-full bg-yellow-400 text-sky-900 text-[9px] font-extrabold px-1.5 py-0.5 ring-2 ring-white leading-none" data-testid={`${testid}-badge`}>{d.badge_text || 'Event-Berater'}</span>}
      </button>
    </div>
  );
};
